import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import { SettingsContext } from '../../contexts';
import { getApiUrl } from '../../core/config/api';

const Header = props => {
    const { isRetailCircle, settings } = useContext(SettingsContext);

    let title;

    switch (props.type) {
        case 'member':
        case 'client':
            title = 'Create a new account'
            break;
        case 'sign-in':
            title = isRetailCircle ? 'Sign In' : 'Log In'
            break;
        case 'recover-account':
            title = 'Recover Account'
            break;
        default: {
            const urlPart = props.type.split('/')[0]

            if (urlPart === 'verify') {
                title = 'Verify Email'
                break
            }

            if (urlPart === 'recover-account') {
                title = 'Set up new password'
                break
            }
        }
    }

    if (isRetailCircle) {
        return (
            <header>
                <Link to="/">
                    <img src="/assets/logo-white.png" className="rc-signin-logo" alt="Retail Circle" />
                </Link>
                <h1>{ title }</h1>
            </header>
        );
    }

    return (
        <header>
            <div className="d-xl-flex justify-content-center">
                <div className="flex-shrink-1 d-flex justify-content-center">
                  {settings.desktop && settings.mobile && (
                    <Link to="/">
                        <img src={getApiUrl(`/api/logos/${settings.desktop}`)} className="logo-desktop" />
                        <img src={getApiUrl(`/api/logos/${settings.desktop}`)} className="logo-mobile" />
                    </Link>
                  )}
                </div>
                <h1 className="align-self-center mt-5 mt-sm-0 mx-0 mx-sm-3">{ title }</h1>
            </div>
        </header>
    )
};

export default Header;
